// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"94eacf5a","540":"94eacf5a","879":"d5ea7348"}[chunkId] + ".chunk.js";
};